import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Button, Col, Form } from "react-bootstrap";
import "./index.css";
import DommusRequiredSpan from "../../../../../../components/DommusRequiredSpan";
import ticketService from "../../../../../../services/TicketService";
import ticketConclusaoService from "../../../../../../services/TicketConclusaoService";
import { useForm } from "react-hook-form";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import guService from "../../../../../../services/GuService";
import Anexos from "../../Chat/Anexos";
import convertFilesToBase64 from "../../../../../../helpers/ConvertFilesToBase64";

export default function ConclusaoChamado({
  chamado,
  dados,
  close,
  refresh,
  setRefresh,
  atualizarChamado,
}) {
  const [listaSolucoes, setListaSolucoes] = useState([]);
  const [solucao, setSolucao] = useState("");
  const [descricao, setDescricao] = useState("");
  const [procedencia, setProcedencia] = useState("");
  const [arquivos, setArquivos] = useState([]);

  const [errorSolucao, setErrorSolucao] = useState(false);
  const [errorDescricao, setErrorDescricao] = useState(false);
  const [errorProcedencia, setErrorProcedencia] = useState(false);

  const { handleSubmit, register, getValues } = useForm();

  const tipoUsuario = useMemo(()=>{
    return Number(guService.getLocalState('tipoUsuario'));
  },[])

  function verificaError() {
    if (solucao === "" || solucao === "Selecione a solucao") {
      setErrorSolucao(true);
    } else {
      setErrorSolucao(false);
    }
    if (descricao === "" && (configSelecionada?.necessario_resposta === true || configSelecionada?.necessario_resposta == null)) {
      setErrorDescricao(true);
    } else {
      setErrorDescricao(false);
    }
  }

  const listaSolucoesFiltradas = useMemo(()=>{
    const motivosPermitidos = chamado?.fluxo_etapa?.motivos_conclusao?.map(Number);
    const listaFiltrada = listaSolucoes.filter((item) => motivosPermitidos?.includes(Number(item.id_ticket_conclusao_tipo)));
    return !!listaFiltrada?.length ? listaFiltrada : listaSolucoes;
  },[listaSolucoes, chamado])

  useEffect(() => {
    ticketConclusaoService.index().then((response) => {
      setListaSolucoes(response.data);
    });
  }, []);

  // const montaArquivo = useCallback((event) => {
  //   let reader = new FileReader();
  //   let file = event.target.files[0];
  //   if (ValidaTipoArquivo.verificaTipoArquivo(file)) {
  //     reader.onload = function (upload) {
  //       let dadosArquivo = {
  //         conteudo: upload.target.result.split(/base64,/)[1],
  //         nome: file.name,
  //       };
  //       setArquivo(dadosArquivo);
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     errorToast.fire({
  //       text: "Tipo de arquivo não suportado, selecione outro ou verifique o mesmo",
  //     });
  //   }
  // }, []);

  const configSelecionada = useMemo(() => {
    let config = null;
    if(solucao){
       let solucaoSelecionada = listaSolucoes.find((item) => item.id_ticket_conclusao_tipo === Number(solucao));
       config = solucaoSelecionada?.configuracao ?? null;
    }
        
    return config;
  },[solucao])

  async function converterArquivos(files){
      if(files.length){
          return await convertFilesToBase64.convertFileToBase64(files);
      }else{
          return [];
      }        
  }

  function cadastraSolucao() {
    let enviarMensagemConclusao = getValues('enviar-mensagem-template');
 
    if (solucao === "" || solucao === "Selecione a solucao") {
      verificaError();
      return;
    }else{
      if (descricao === "" && (configSelecionada?.necessario_resposta == null || configSelecionada?.necessario_resposta)) {
        verificaError();
        return;
      } else {
        let mensagem = `${enviarMensagemConclusao ? "Será enviado uma mensagem para o cliente informando a conclusão do ticket." : "O chamado será concluído. "}Deseja prosseguir?`;
        Swal.fire({
          title: 'Conclusão de Chamado',
          text: mensagem,
          icon: 'question',
          confirmButtonText: 'Sim, enviar e finalizar ticket',
          showDenyButton: true,
          denyButtonText: 'Não prosseguir',
          confirmButtonColor: 'var(--dommus-color)'
        }).then(async (resposta) => {
          if(resposta.isConfirmed) {
            const arquivosConvertidos = await converterArquivos(arquivos);        
            const arquivosTratados = arquivosConvertidos.map(arquivo => {
                arquivo.extensao = arquivo.tipo
                return arquivo
            })
            let dadosConcusao = {
              id_ticket_conclusao_tipo: solucao,
              descricao: descricao,
              procedencia_solicitacao: procedencia,
              data_conclusao: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
              dados_arquivo: arquivosTratados,
              enviar_mensagem_conclusao: getValues('enviar-mensagem-template'),
            };
            trackPromise(
              ticketConclusaoService.store(dadosConcusao, chamado.id_ticket).then(
                (res) => {                  
                  close();
                  trackPromise(ticketService.update(chamado.id_ticket, dados).then(
                    (response) => {
                      Swal.fire({
                        titleText: "Chamado finalizado",
                        text: "Seu chamado foi concluído com sucesso!",
                        icon: "success",
                      }).then(() => {        
                    
                        if(atualizarChamado){
                          atualizarChamado(response.data)
                        }
                        if(setRefresh && guService.getLocalState('exibicaoLista') !== 'K'){
                          setRefresh((current) => !current);
                        }
                      });
                    },
                    (error) => {
                      Swal.fire({
                        titleText: "Ooops...",
                        text: "Ocorreu um erro ao salvar o chamado: " + error,
                        icon: "error",
                      });
                    }
                  ));
                },
                (error) => {
                  const errorMessage = error.response?.data?.message || error.message || error;
                  Swal.fire({
                    titleText: "Ooops...",
                    text: "Ocorreu um erro ao concluir o chamado: " + errorMessage,
                    icon: "error",
                  });
                }
              )
            );
          }
        })
      }
     }
    }
  

  return (
    <div>
      <div
        className="tituloNovoChamado"
        style={{ 
          backgroundColor: "var(--dommus-color)"          
        }}
      >
        <h5 className="mb-0">Solução do Chamado</h5>
      </div>
      <Form
        className="novaIndicacaoForm mt-2 conclusao-form"
        onSubmit={handleSubmit(cadastraSolucao)}
      >
        <div       
          style={{
            maxHeight: "70vh",
            overflowY: "auto"
          }}
        >
          <Form.Group as={Col} controlId="formMotivo">
            <Form.Label>
              Solução: <DommusRequiredSpan />
            </Form.Label>
            <Form.Control
              onBlur={() => verificaError()}
              name="solucao"
              ref={register()}
              as="select"
              custom
              value={solucao}
              onChange={(event) => setSolucao(event.target.value)}
            >
              <option>Selecione a solução</option>
              {listaSolucoesFiltradas.map((solucao, index) => (
                <option key={index} value={solucao.id_ticket_conclusao_tipo}>
                  {solucao.nome}
                </option>
              ))}
            </Form.Control>
            {errorSolucao ? (
              <p className="campoError">Campo Obrigatório</p>
            ) : (
              <></>
            )}
          </Form.Group>

          <Form.Group as={Col} controlId="formDescricao">
            <Form.Label>
              Resposta que será encaminhada ao cliente, informado a conclusão do ticket: 
              {configSelecionada?.necessario_resposta === false ? <></> :  <DommusRequiredSpan />}
            </Form.Label>
            <Form.Control
              onBlur={() => verificaError()}
              name="descricao"
              ref={register()}
              as="textarea"
              rows={10}
              value={descricao}
              onChange={(event) => setDescricao(event.target.value)}
            ></Form.Control>
            {errorDescricao ? (
              <p className="campoError">Campo Obrigatório</p>
            ) : (
              <></>
            )}
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Check 
              type={"checkbox"}
              id={`checkbox-template`}
              ref={register()}
              name="enviar-mensagem-template"
              defaultChecked={true}
              disabled={configSelecionada?.tipos_usuarios_desmarca_envio_template && configSelecionada?.tipos_usuarios_desmarca_envio_template?.includes(tipoUsuario) ? false : true}
              label={`Enviar mensagem de conclusão`}
            />
          </Form.Group>
               
          { chamado?.categoria?.tipo == 'AT' 
          && <>
          <Form.Group as={Col}>
          <FormControl>
            <Form.Label>Procedência</Form.Label>
            <RadioGroup
                row
                aria-labelledby="procedencia-row"
                name="row-radio-procedencia"
              >
              <FormControlLabel onChange={e => setProcedencia('P')} value="P" control={<Radio />} label="Procedente" />
              <FormControlLabel onChange={e => setProcedencia('I')} value="I" control={<Radio />} label="Improcedente" />
            </RadioGroup>
          </FormControl>
          {errorProcedencia ? (
              <p className="campoError">Campo Obrigatório</p>
            ) : (
              <></>
            )}
          </Form.Group>
          </>}

          <Form.Group as={Col} controlId="formNome">
            <div className="av-item select-file">
              <div className="documentacao-item-wrapper">
                <div className="form-group">
                  <div>
                    <h6>Arquivos:</h6>
                  </div>
                  <div className="upload-wrapper">
                    <div id="documento-0" className="documento-conclusao-wrapper">
                      <div>
                        <Anexos
                            listaAnexos={arquivos}
                            setListaAnexos={setArquivos}
                            filesTypes={'image/*, application/pdf'}
                            descricao="Arraste ou clique. Max. 5Mb"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form.Group>
        </div>
        <Col className="btns-section">
          <Button variant="secondary" onClick={()=>{close()}}>Cancelar</Button>
          <Button
            variant="primary"
            className="btn-salvar"
            type="submit"
          >
            Salvar
          </Button>
        </Col>
      </Form>
    </div>
  );
}
